export default "__VITE_ASSET__a0fe1492__"